import { Component, OnInit, Input, EventEmitter, ViewChild, Output, TemplateRef, OnDestroy } from '@angular/core';
import { findIndex, remove, find, forEach } from 'lodash';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { LocalDataSource } from 'ng2-smart-table';
import { ToastrService } from 'ngx-toastr';
import {
  Context,
  Tarea,
  Usuario,
  Asignacion,
  GlobalInfo,
  ConfirmComponent,
  Const,
  TareaRol,
  TaskEvent
} from '@app/shared';
import { GlobalInfoService, Logger } from '@app/core';
import { HistoryAssignment } from './../../all/assignment-form/assignment-form.component';
import { AssignmentConfig } from './shared/assignment.config.service';
import { AssignmentService } from './shared/assignment.service';
import { Subject } from 'rxjs';

const log = new Logger('AssignmentFoAssignmentComponentrmComponent');

@Component({
  selector: 'iw-assignment',
  templateUrl: './assignment.component.html',
  styleUrls: ['./assignment.component.scss'],
  providers: [AssignmentService]
})
export class AssignmentComponent implements OnInit, OnDestroy {

  // Contexto del formulario, es suministrado dinámicamente
  @Input() ctx: Context;
  // Evento para finalizar y cerrar la modal, es suministrado dinámicamente
  @Input() event: EventEmitter<any>;
  // Define si es una asignacion para finalizar la acarga de datos
  @Input() finishDataLoad = false;
  // Determina si el usuario en sesion es responsable de la tarea
  @Input() userResponsible = false;
  // Define si la tarea esta finalizada
  @Input() finishTask = false;
  // Tarea siguiente, a la que se le van asignar los responsables
  @Input() set nextTask(t: Tarea) {
    if (t && t.responsables && t.responsables.length) {
      this.responsibles = t.responsables;
    }
    this._nextTask = t;
  }
  // Define si hay una secundaria iniciada
  @Input() secondaryActive = false;
  // tipo del proceso de la tarea renderizada
  typeProcess: string;
  // Contiene el id del grupo seleccionado
  rolId = -1;
  // Tarea actual
  task: Tarea;
  // Determina si se esta realizando alguna petición al backend
  isLoading = false;
  // Determina cuando esta consultando los usuarios del grupo
  isLoadingUser = false;
  // Define cuando se muestra la carga de la tabla
  loaderTable = false;
  // Define cuando se muestra el boton de buscar
  SearchButton = false;
  // numero de registros de la tabla
  pageSize = 10;
  // Usuarios del rol(grupo) seleccionado
  users: Usuario[];
  // Contiene el historial de asignaciones
  historyAssign: Asignacion;
  // Usuarios seleccionados para ser los responsables de la tarea
  responsibles: Usuario[] = [];
  // Información global de la app
  gi: Partial<GlobalInfo>;
  // contiene la configuracion de la tabla
  settings = {};
  // Datos para llenar la tabla de historial de asignaciones
  source: LocalDataSource;
  // Datos para llenar la tabla dfe usuarios del grupo
  sourceUser: LocalDataSource = new LocalDataSource();
  // contiene la configuracion de la tabla
  settingsUsers = {};
  // Referencia de la modal
  modalRef: BsModalRef;
  // Modal de historial de asignaciones
  @ViewChild('templateHistoryAssign') private templateHistoryAssign: TemplateRef<any>;
  // Referencia al componente de confirmación
  @ViewChild('confirmFinish') private confirmFinish: ConfirmComponent;
  // Indica el cierre del componente de asignaciones
  @Output() closeAssignment = new EventEmitter<boolean>();
  // Tarea siguiente
  private _nextTask: Tarea;
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();

  constructor(
    private as: AssignmentService,
    private modalService: BsModalService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    if (this.finishDataLoad) {
      this.userResponsible = true;
    }
    this.task = this.ctx.task;
    this.typeProcess = this.ctx.typeProcess;
    // Se inicia la configuracion de la tabla
    const configTable = new AssignmentConfig();
    this.settings = configTable.getSettingsTableRejects();
    this.settingsUsers = configTable.getSettingsTableAssignment();
    this.as.getHistoryAssign(this.task.id).subscribe(res => {
      res.historial.sort((a, b) => b.version - a.version);
      this.historyAssign = res;
    });
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  get nextTask() {
    return this._nextTask;
  }

  /**
   * Consulta los usuarios del rol(grupo) seleccionado.
   *
   * @param {TareaRol} role
   * @memberof AssignmentComponent
   */
  chooseRole(role: TareaRol) {
    if (this.rolId !== role.rol_id) {
      this.isLoadingUser = true;
      this.rolId = role.rol_id;
      this.sourceUser.empty();
      this.as.getRole(role.rol_id).then(async r => {
        if (r.rol_user && r.rol_user.length) {
          r.rol_user.forEach((user, i) => {
            r.rol_user[i]['select'] = this.isAssigned(user);
            r.rol_user[i]['nombre'] = user.first_name + ' ' + user.last_name;
          });
        }
        this.users = r.rol_user;
        this.sourceUser = new LocalDataSource(this.users);
        this.sourceUser.onChanged().subscribe(async (change: { action: string; filter: { filters: string | any[]; }; paging: { page: any; }; }) => {
          if (change.action === 'page' && this.sourceUser['data'].length) {
            let checkFilter = false;
            if (change.filter.filters.length){
              forEach(change.filter.filters,f=>{
                if(f.search !=""){
                  checkFilter = true;
                }
              })
            }
            if (!checkFilter){
              this.pageChange(change.paging.page);
            }
            
          }else if(change.action === 'filter' && this.sourceUser['data'].length && change.filter.filters.length){
            let checkFilter = false;
            forEach(change.filter.filters,f=>{
              if(f.search !=""){
                checkFilter = true;
              }
            })
            if(checkFilter){
              this.SearchButton = true;
            }else{
              this.SearchButton = false;
              if (this.rolId){
                this.loaderTable = true;
                this.as.getRole(this.rolId)
                .then(async data => {
                  if (data.rol_user && data.rol_user.length) {
                    data.rol_user.forEach((user, i) => {
                      data.rol_user[i]['select'] = this.isAssigned(user);
                      data.rol_user[i]['nombre'] = user.first_name + ' ' + user.last_name;
                    });
                  }
                  this.users = r.rol_user;
                  if (this.sourceUser.count() > 0){
                    this.sourceUser.empty();
                    // Reload the data
                    this.sourceUser.load(this.users);
  
                    // Refresh the data source
                    //this.sourceUser.refresh();
                    this.loaderTable = false;
                }
                  else{
                    this.sourceUser.load(this.users);
                    this.loaderTable = false;
                  }
                });
              }
              
                  
            }
          }
        });
        this.sourceUser.refresh();
        this.isLoadingUser = false;
      });
    }
  }

  /**
   * Asigna un usuario como responsable.
   *
   * @param {*} user
   * @memberof AssignmentComponent
   */
  chooseUser(user: any) {
    const listUser: any[] = this.sourceUser['data'];
    const userIndex = findIndex(listUser, {id: user.data.id});
    // Eliminar responable si existe
    const removed = remove(this.responsibles, u => {
      return u.id === user.data.id;
    });
    if (!removed.length) {
      this.responsibles.push(user.data);
      if (userIndex !== -1) {
        listUser[userIndex]['select'] = true;
        //this.sourceUser.data[userIndex]['select'] = true;
        this.sourceUser.empty();
        this.sourceUser.load(listUser);
        this.sourceUser.refresh();
      }
    } else {
      if (userIndex !== -1) {
        listUser[userIndex]['select'] = false;
        this.sourceUser.empty();
        this.sourceUser.load(listUser);
        //this.sourceUser.data[userIndex]['select'] = false;
        this.sourceUser.refresh();
      }
    }
  }

  /**
   * Valida si un usuario esta asignado.
   *
   * @param {Usuario} user
   * @returns {boolean}
   * @memberof AssignmentComponent
   */
  isAssigned(user: Usuario): boolean {
    const userResponsible = find(this.responsibles, { id: user.id });
    if (userResponsible) {
      return true;
    }
    return false;
  }

  /**
   * Esta funcion se ejecuta para filtar datos de tablas
   *
   * @param {Any} source
   * @memberof AssignmentComponent
   */
  filterData(source: any) {
    if(source.filterConf && source.filterConf.filters.length){
      let filterFields: any[] = []
      forEach(source.filterConf.filters, (fil:any)=>{
        if(fil.search != ""){filterFields.push({"column":fil.field,"valor":fil.search})}
      })
      if (filterFields.length){
        this.loaderTable = true;

      this.as.getRole(this.rolId,0,50,filterFields)
      .then(async data => {
        if (data.rol_user && data.rol_user.length) {
          data.rol_user.forEach((user, i) => {
            data.rol_user[i]['select'] = this.isAssigned(user);
            data.rol_user[i]['nombre'] = user.first_name + ' ' + user.last_name;
          });
        }
        // Store the current filters
          //const currentFilters = this.sourceUser.getFilter();
          this.sourceUser.empty();
          // Reload the data
          this.sourceUser.load(data.rol_user);

          this.loaderTable = false;
      })
      }else{
        this.loaderTable = true;
        this.as.getRole(this.rolId)
        .then(async data => {
          if (data.rol_user && data.rol_user.length) {
            data.rol_user.forEach((user, i) => {
              data.rol_user[i]['select'] = this.isAssigned(user);
              data.rol_user[i]['nombre'] = user.first_name + ' ' + user.last_name;
            });
          }
          if (this.sourceUser.count() > 0){
            this.sourceUser.empty();
            // Reload the data
            this.sourceUser.load(data.rol_user);

            // Refresh the data source
            //this.sourceUser.refresh();
            this.loaderTable = false;
        }
          else{
            this.sourceUser.load(data.rol_user);
            this.loaderTable = false;
          }
        })
      }
      
    }else{
      this.loaderTable = true;
      this.as.getRole(this.rolId) //.toPromise()
      .then(async data => {
        if (data.rol_user && data.rol_user.length) {
          data.rol_user.forEach((user, i) => {
            data.rol_user[i]['select'] = this.isAssigned(user);
            data.rol_user[i]['nombre'] = user.first_name + ' ' + user.last_name;
          });
        }
        if (this.sourceUser.count() > 0){
          this.sourceUser.empty();
          // Reload the data
          this.sourceUser.load(data.rol_user);
          this.loaderTable = false;

          // Refresh the data source
          //this.sourceUser.refresh();
      }
        else{
          this.loaderTable = false;
          this.sourceUser.load(data.rol_user);
        }
      })
    }  
  }

  pageChange(pageIndex:any) {
    let loadedRecordCount = this.sourceUser.count();
    let lastRequestedRecordIndex = pageIndex * this.pageSize;
  
    if (loadedRecordCount <= lastRequestedRecordIndex) {    
      let startIndex =  loadedRecordCount + 1;
      let recordCount = lastRequestedRecordIndex + 50; //extra 100 records improves UX.

      this.loaderTable = true;
        this.as.getRole(this.rolId,startIndex,recordCount) //.toPromise()
        .then(async data => {
          if (data.rol_user && data.rol_user.length) {
            data.rol_user.forEach((user, i) => {
              data.rol_user[i]['select'] = this.isAssigned(user);
              data.rol_user[i]['nombre'] = user.first_name + ' ' + user.last_name;
            });
          }
          if (this.sourceUser.count() > 0){
            //this.sourceUser.empty();
            data.rol_user.forEach(user => {
              this.sourceUser.add(user);
            });
            const allData = await this.sourceUser.getAll();
            this.sourceUser.load(allData);
            this.loaderTable = false;
            this.loaderTable = false;
        }
          else{
            this.sourceUser.load(data.rol_user);
          }
        });
    }
  }

  /**
   * Abre la modal de historial de asignaciones
   *
   * @memberof AssignmentComponent
   */
  openFormCreateControl() {
    const historys: HistoryAssignment[] = [];
    if (this.historyAssign.historial && this.historyAssign.historial.length) {
      this.historyAssign.historial.forEach(history => {
        let responsibleAssignment = '';
        let responsiblerejection = '';
        let userAssignment = '';

        if (history.responsables && history.responsables.length) {
          history.responsables.forEach((responsible, index) => {
            if (index > 0) {
              responsibleAssignment += ' , ';
            }
            responsibleAssignment += responsible.nombres + ' ' + responsible.apellidos;
          });
        }

        if (history.usuarios_asignados && history.usuarios_asignados.length) {
          history.usuarios_asignados.forEach((userAssign, index) => {
            if (index > 0) {
              userAssignment += ' , ';
            }
            userAssignment += userAssign.nombres + ' ' + userAssign.apellidos;
          });
        }
        if (history.rechazo) {
          if (history.rechazo.responsable) {
            responsiblerejection += history.rechazo.responsable.nombres + ' ' + history.rechazo.responsable.apellidos;
          }
        }

        historys.push({
          fecha_registro: new Date(history.fecha_registro).toLocaleDateString(),
          fecha_finalizacion: new Date(history.fecha_finalizacion).toLocaleDateString(),
          responsable: responsibleAssignment,
          usuarios_asignados: userAssignment,
          fecha_rechazo: history.rechazo ? new Date(history.rechazo.fecha_rechazo).toLocaleDateString() : null,
          descripcion: history.rechazo ? history.rechazo.descripcion : null,
          responsable_rechazo: responsiblerejection,
        });

      });
    }

    this.source = new LocalDataSource(historys);
    this.source.refresh();

    this.modalRef = this.modalService.show(this.templateHistoryAssign, { class: 'modal-lg-personalized'});
  }

  /**
   * Evento que finaliza la tarea.
   *
   * @memberof AssignmentComponent
   */
  finish(confimation?: boolean) {
    if (confimation) {
      this.isLoading = true;
      const responsibles: number[] = [];
      this.responsibles.forEach(r => {
        responsibles.push(r.id);
      });
      if (!this.finishDataLoad) {
        this.as
          .assign(this.task, responsibles)
          .finally(() => {
            this.isLoading = false;
          })
          .subscribe(res => {
            if (res) {
              this.event.emit({
                type: 'finish',
                params: {
                  skip: true
                }
              } as TaskEvent);
            } else {
              log.error('Ocurrió algún problema asignar la tarea.');
            }
            this.isLoading = false;
          });
      } else {
        this.as
          .finishDataLoad(this.task, responsibles)
          .finally(() => {
            this.isLoading = false;
          })
          .subscribe(res => {
            if (res) {
              this.closeAssignment.emit(true);
            } else {
              log.error('Ocurrió algún problema asignar la tarea.');
            }
            this.isLoading = false;
          });
      }
    }
  }

  /**
   * Validad que la tarea se pueda finalizar
   *
   * @memberof AssignmentComponent
   */
  finishConfirm() {
    if (this.responsibles.length && this.userResponsible && !this.finishTask && !this.secondaryActive) {
      this.confirmFinish.open();
    } else {
      if (!this.userResponsible) {
        this.toastr.error('Usted no posee los permisos suficientes para ejecutar esta acción.', 'Permiso denegado');
      } else if (this.finishTask) {
        this.toastr.error('La tarea ya está finalizada.', 'Acción no permitida');
      } else if (this.secondaryActive) {
        this.toastr.error(
          'No se puede realizar esta acción debido a que se encuentra un procesos secundario en progreso.',
          'Acción no permitida'
        );
      } else if (!this.responsibles.length) {
          this.toastr.error('Debe seleccionar al menos un responsable.', 'Información incompleta');
      } else {
        this.toastr.error(
          'Lo sentimos ha ocurrido un error inesperado, inténtalo de nuevo más tarde.',
          'Error inesperado'
        );
      }
    }
  }

}




// WEBPACK FOOTER //
// ./src/app/forms/shared/assignment/assignment.component.ts